'use strict';

const Tracking = {
    hasConsent: false,
    debug: window.location.hostname === 'localhost' || window.localStorage.getItem('debug') === 'true',

    init: function () {
        const checkAxeptio = () => {
            if (typeof axeptioSDK !== 'undefined') {
                this.log('[Tracking] Axeptio SDK détecté');
                axeptioSDK.on('cookies:complete', (choices) => {
                    this.log('[Tracking] Consentement reçu', choices);
                    if (choices.googletagmanager) {
                        this.log('[Tracking] Consentement GTM OK');
                        this.hasConsent = true;
                        this.pushPageView();
                        this.bindNavigationTracking();
                        this.bindSocialShareTracking();
                        this.bindCTATracking();
                        this.initAdvancedYouTubeTracking();
                        this.bindAddToCartCtaTracking();
                    }
                });
            } else {
                this.log('[Tracking] En attente de axeptioSDK...');
                setTimeout(checkAxeptio, 300); // Retry until axeptioSDK is ready
            }
        };

        checkAxeptio();
    },

    log: function (...args) {
        if (this.debug) {
            console.log(...args);
        }
    },

    getPageViewContext: function () {
        return {
            page_location: window.location.href,
            page_path: window.location.pathname + window.location.search,
            page_title: document.title,
            page_referrer: document.referrer
        };
    },

    getPageType: function () {
        const classes = document.body.classList;

        if (classes.contains('home')) return 'homepage';
        if ([...document.body.classList].some(className => className.includes('404'))) return '404';
        if ([...document.body.classList].some(className => className.includes('single-actualite'))) return 'actualite';
        if ([...document.body.classList].some(className => className.includes('single-defi'))) return 'defi';
        if ([...document.body.classList].some(className => className.includes('single-projet_soutenu'))) return 'projet-soutenu';
        if ([...document.body.classList].some(className => className.includes('single-projet'))) return 'projet';
        if ([...document.body.classList].some(className => className.includes('single-publication'))) return 'publication';
        if ([...document.body.classList].some(className => className.includes('tpl-cart'))) return 'panier';
        if ([...document.body.classList].some(className => className.includes('tpl-contact'))) return 'contact';
        if ([...document.body.classList].some(className => className.includes('tpl-donation-share'))) return 'remerciement-donation';
        if ([...document.body.classList].some(className => className.includes('tpl-listing-actualite'))) return 'liste-actualites';
        if ([...document.body.classList].some(className => className.includes('tpl-listing-chercheur'))) return 'liste-chercheurs';
        if ([...document.body.classList].some(className => className.includes('tpl-listing-defi'))) return 'liste-defis';
        if ([...document.body.classList].some(className => className.includes('tpl-listing-faq'))) return 'liste-faqs';
        if ([...document.body.classList].some(className => className.includes('tpl-listing-projet_soutenu'))) return 'liste-projets-soutenus';
        if ([...document.body.classList].some(className => className.includes('tpl-listing-projet'))) return 'liste-projets';
        if ([...document.body.classList].some(className => className.includes('tpl-listing-publications'))) return 'liste-publications';
        if ([...document.body.classList].some(className => className.includes('tpl-listing-video'))) return 'liste-videos';
        if ([...document.body.classList].some(className => className.includes('search-results'))) return 'recherche';
        if ([...document.body.classList].some(className => className.includes('default'))) return 'default';

        return 'undefined';
    },

    pushPageView: function () {
        if (typeof window.dataLayer === 'undefined') return;

        const data = {
            event: 'page_view',
            ...this.getPageViewContext()
        };
        window.dataLayer.push(data);
        this.log('[Tracking] page_view', data);
    },

    bindNavigationTracking: function () {
        const navSelectors = [
            {selector: '[data-track-nav="header_level_1"]', level: 'header_level_1'},
            {selector: '[data-track-nav="header_level_2"]', level: 'header_level_2'},
            {selector: '[data-track-nav="header_level_3"]', level: 'header_level_3'},
            {selector: '[data-track-nav="footer_sitemap"]', level: 'footer_sitemap'},
            {selector: '[data-track-nav="footer_highlighted_page"]', level: 'footer_highlighted_page'},
            {selector: '[data-track-nav="footer_contact"]', level: 'footer_contact'},
            {selector: '[data-track-nav="footer_utility_bar"]', level: 'footer_utility_bar'}
        ];

        navSelectors.forEach(({selector, level}) => {
            document.querySelectorAll(selector).forEach((el) => {
                el.addEventListener('click', () => {
                    if (!this.hasConsent || typeof window.dataLayer === 'undefined') return;
                    const data = {
                        event: 'navigation',
                        path_level: level,
                        click_text: el.textContent.trim(),
                        click_url: el.href,
                        ...this.getPageViewContext()
                    };
                    window.dataLayer.push(data);
                    this.log('[Tracking] navigation', data);
                });
            });
        });
    },

    bindSocialShareTracking: function () {
        const buttons = document.querySelectorAll('[data-track-social]');
        buttons.forEach((btn) => {
            btn.addEventListener('click', () => {
                if (!this.hasConsent || typeof window.dataLayer === 'undefined') return;
                const network = btn.getAttribute('data-track-social');
                if (network) {
                    const data = {
                        event: 'social_share',
                        social_name: network,
                        ...this.getPageViewContext()
                    };
                    window.dataLayer.push(data);
                    this.log('[Tracking] social_share', data);
                }
            });
        });
    },

    bindCTATracking: function () {
        document.addEventListener('click', (e) => {
            if (e.target.matches('[data-track-cta]') || e.target.closest('[data-track-cta]')) {
                let el;
                if (e.target.matches('[data-track-cta]')) {
                    el = e.target;
                } else {
                    el = e.target.closest('[data-track-cta]');
                }

                if (!this.hasConsent || typeof window.dataLayer === 'undefined') return;

                const data = {
                    event: 'cta_click',
                    cta_type: el.dataset.ctaType || 'lien',
                    cta_position: el.dataset.ctaPosition || '',
                    cta_id: el.dataset.ctaId || '',
                    page_context: this.getPageType(),
                    click_text: el.dataset.text ?? el.textContent.trim(),
                    click_url: el.href,
                    ...this.getPageViewContext()
                };
                window.dataLayer.push(data);
                this.log('[Tracking] cta_click', data);

                if (el.dataset.ctaType === 'telechargement') {
                    setTimeout(() => {
                        const dataDownload = {
                            event: 'file_download',
                            cta_type: 'telechargement',
                            cta_position: el.dataset.ctaPosition || '',
                            cta_id: el.dataset.ctaId || '',
                            page_context: this.getPageType(),
                            click_text: el.dataset.text ?? el.textContent.trim(),
                            click_url: el.href,
                            file_name: this.generateSlug(el.dataset.title) || '',
                            file_type: this.generateSlug(el.dataset.type) || '',
                            file_extension: this.generateSlug(el.dataset.extension) || '',
                            ...this.getPageViewContext()
                        };
                        window.dataLayer.push(dataDownload);
                        this.log('[Tracking] file_download', dataDownload);
                    }, 50);

                }
            }
        });
    },

    bindAddToCartCtaTracking: function () {
        document.addEventListener('click', (e) => {
            if (e.target.matches('.addToCart') || e.target.closest('.addToCart')) {
                // Ajout au panier
                let el;
                if (e.target.matches('.addToCart')) {
                    el = e.target;
                } else {
                    el = e.target.closest('.addToCart');
                }
                Tracking.handleAddToCartClick(el);
            }
        });
    },

    handleAddToCartClick: function (el) {
        if (!Tracking.hasConsent || typeof window.dataLayer === 'undefined') return;

        const data = {
            event: 'add_to_cart',
            cta_position: el.dataset.ctaPosition || '',
            cta_id: el.dataset.ctaId || '',
            page_context: Tracking.getPageType(),
            ecommerce: {
                currency: 'EUR',
                value: 0,
                items: [{
                    item_id: el.dataset.idPublication,
                    item_name: el.dataset.titlePublication,
                    item_brand: 'Fondation ARC',
                    item_category: el.dataset.typePublication || '',
                    item_category_2: el.dataset.editionPublication || '',
                    price: 0,
                    quantity: 1
                }]
            },
            ...Tracking.getPageViewContext()
        };
        window.dataLayer.push(data);
        Tracking.log('[Tracking] add_to_cart', data);
    },

    handleQuantityIncrease: function (event, quantity = 1) {
        const el = event.currentTarget;
        if (!Tracking.hasConsent || typeof window.dataLayer === 'undefined') return;

        const li = el.closest('li');
        const id = li.dataset.id;
        const edition = li.dataset.edition;
        const type = li.dataset.type;
        const title = li.dataset.title;

        const data = {
            event: 'add_to_cart',
            page_context: 'recap_panier',
            ecommerce: {
                currency: 'EUR',
                value: 0,
                items: [{
                    item_id: id,
                    item_name: title,
                    item_brand: 'Fondation ARC',
                    item_category: type,
                    item_category_2: edition,
                    price: 0,
                    quantity: quantity
                }]
            },
            ...Tracking.getPageViewContext()
        };
        window.dataLayer.push(data);
        Tracking.log('[Tracking] add_to_cart quantité augmentée', data);
    },

    handleQuantityDecrease: function (event, quantity = 1) {
        const el = event.currentTarget;
        if (!Tracking.hasConsent || typeof window.dataLayer === 'undefined') return;

        const li = el.closest('li');
        const id = li.dataset.id;
        const edition = li.dataset.edition;
        const type = li.dataset.type;
        const title = li.dataset.title;

        const data = {
            event: 'remove_from_cart',
            page_context: 'recap_panier',
            ecommerce: {
                items: [{
                    item_id: id,
                    item_name: title,
                    item_brand: 'Fondation ARC',
                    item_category: type,
                    item_category_2: edition,
                    price: 0,
                    quantity: quantity
                }]
            },
            ...Tracking.getPageViewContext()
        };
        window.dataLayer.push(data);
        Tracking.log('[Tracking] remove_from_cart', data);
    },

    bindCheckoutCtaTracking: function (items) {
        if (!this.hasConsent || typeof window.dataLayer === 'undefined') return;

        const data = {
            event: 'begin_checkout',
            ecommerce: {
                currency: 'EUR',
                value: 0,
                items: items
            }
        };
        window.dataLayer.push(data);
        this.log('[Tracking] begin_checkout', data);
    },

    bindViewCartTracking: function (items) {
        if (!this.hasConsent || typeof window.dataLayer === 'undefined') return;

        const data = {
            event: 'view_cart',
            ecommerce: {
                currency: 'EUR',
                value: 0,
                items: items
            }
        };
        window.dataLayer.push(data);
        this.log('[Tracking] view_cart', data);
    },

    bindPurchaseTracking: function (items, userType, id) {
        if (!this.hasConsent || typeof window.dataLayer === 'undefined') return;

        const data = {
            event: 'purchase',
            user_type: userType,
            ecommerce: {
                transaction_id: id,
                currency: 'EUR',
                value: 0,
                items: items
            }
        };
        window.dataLayer.push(data);
        this.log('[Tracking] purchase', data);
    },

    // Fonction utilitaire pour générer un slug à partir d'un titre
    generateSlug: function (title) {
        return title
            .toLowerCase()
            .normalize('NFD') // Décompose les caractères accentués
            .replace(/[\u0300-\u036f]/g, '') // Supprime les accents
            .replace(/[^a-z0-9\s-]/g, '') // Supprime les caractères spéciaux
            .trim()
            .replace(/\s+/g, '-') // Remplace les espaces par des tirets
            .replace(/-+/g, '-'); // Évite les tirets multiples
    }
    ,

    pushVirtualPageView: function ({title, hash, type}) {
        if (!this.hasConsent || typeof window.dataLayer === 'undefined') return;

        // Générer le hash automatiquement si non fourni
        const generatedHash = hash || this.generateSlug(title);

        // Construire l'URL virtuelle avec le hash
        const virtualPageLocation = window.location.origin + window.location.pathname + '#' + generatedHash;
        const virtualPagePath = window.location.pathname + '#' + generatedHash;

        // Le page_referrer est l'URL de la page actuelle (sans le hash)
        const pageReferrer = window.location.href.split('#')[0];

        const data = {
            event: 'virtual_page_view',
            page_location: virtualPageLocation,
            page_path: virtualPagePath,
            page_title: title,
            page_referrer: pageReferrer,
            virtual_page_type: type
        };
        window.dataLayer.push(data);
        this.log('[Tracking] virtual_page_view', data);
    }
    ,

    initAdvancedYouTubeTracking: function () {
        if (!this.hasConsent || typeof window.dataLayer === 'undefined') return;

        this.youTubePlayers = [];
        this.youTubeProgressTimers = {};

        const setupStaticIframes = () => {
            const iframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"], iframe[src*="youtube-nocookie.com"]');
            iframes.forEach((iframe) => this.attachYouTubePlayer(iframe));
        };

        if (typeof YT !== 'undefined' && typeof YT.Player !== 'undefined') {
            setupStaticIframes();
            this.observeNewYouTubeIframes();
        } else {
            const previousCallback = window.onYouTubeIframeAPIReady;
            window.onYouTubeIframeAPIReady = () => {
                if (typeof previousCallback === 'function') previousCallback();
                setupStaticIframes();
                this.observeNewYouTubeIframes();
            };

            const tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild(tag);
        }
    }
    ,

    isYouTubeIframe: function (iframe) {
        // Check if the element is actually an iframe
        if (!iframe || iframe.tagName !== 'IFRAME') {
            return false;
        }

        // Get all possible src attributes
        const src = iframe.src || iframe.getAttribute('src') || '';
        const dataSrc = iframe.getAttribute('data-src') || '';
        const lazySrc = iframe.getAttribute('data-lazy-src') || '';

        // All URLs to check
        const urlsToCheck = [src, dataSrc, lazySrc].filter(Boolean);

        // YouTube domain patterns
        const youtubeHosts = [
            'youtube.com',
            'www.youtube.com',
            'youtube-nocookie.com',
            'www.youtube-nocookie.com',
            'youtu.be',
            'm.youtube.com'
        ];

        // Check each URL
        return urlsToCheck.some(url => {
            try {
                // Handle protocol-relative URLs
                const fullUrl = url.startsWith('//') ? 'https:' + url : url;
                const urlObj = new URL(fullUrl);

                // Check if hostname matches YouTube domains
                const isYouTubeDomain = youtubeHosts.some(host =>
                    urlObj.hostname === host || urlObj.hostname.endsWith('.' + host)
                );

                // Additional check for embed path
                const hasEmbedPath = urlObj.pathname.includes('/embed/') ||
                    urlObj.hostname === 'youtu.be';

                return isYouTubeDomain && (hasEmbedPath || urlObj.hostname === 'youtu.be');

            } catch (error) {
                // Fallback to regex if URL parsing fails
                const youtubePatterns = [
                    /^https?:\/\/(www\.)?youtube\.com\/embed\//,
                    /^https?:\/\/(www\.)?youtube-nocookie\.com\/embed\//,
                    /^https?:\/\/youtu\.be\//,
                    /^\/\/.*youtube.*\.com\/embed\//
                ];

                return youtubePatterns.some(pattern => pattern.test(url));
            }
        });
    }
    ,

    observeNewYouTubeIframes: function () {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1) {
                        if (node.tagName === 'IFRAME' && this.isYouTubeIframe(node)) {
                            this.attachYouTubePlayer(node);
                        } else if (node.querySelectorAll) {
                            node.querySelectorAll('iframe').forEach((iframe) => {
                                if (this.isYouTubeIframe(iframe)) {
                                    this.attachYouTubePlayer(iframe);
                                }
                            });
                        }
                    }
                });
            });
        });

        observer.observe(document.body, {childList: true, subtree: true});
    }
    ,

    attachYouTubePlayer: function (iframe) {
        if (iframe.dataset.tracked === 'true') return; // évite double tracking
        iframe.dataset.tracked = 'true';

        const player = new YT.Player(iframe, {
            events: {
                onStateChange: (event) => this.onPlayerStateChange(event, iframe)
            }
        });

        this.youTubePlayers.push(player);
    }
    ,

    getVideoTitle: function (iframe) {
        // 1. Attribut title de l'iframe
        if (iframe.title && iframe.title !== 'YouTube video player') {
            return iframe.title;
        }

        // 2. Attribut data-video-title personnalisé
        if (iframe.getAttribute('data-video-title')) {
            return iframe.getAttribute('data-video-title');
        }

        // 3. Conteneur parent avec data-video-title
        const container = iframe.closest('[data-video-title]');
        if (container) {
            return container.getAttribute('data-video-title');
        }

        // 4. Titre dans un élément proche (h1-h6, .video-title, etc.)
        const parent = iframe.closest('div, section, article');
        if (parent) {
            const titleElement = parent.querySelector('h1, h2, h3, h4, h5, h6, .video-title, .title');
            if (titleElement) {
                return titleElement.textContent.trim();
            }
        }

        // 5. Fallback générique
        return 'YouTube Video';
    }
    ,

    onPlayerStateChange: function (event, iframe) {
        const player = event.target;

        const videoData = {
            title: iframe.title || 'YouTube Video',
            url: iframe.src,
            provider: 'YouTube'
        };

        const duration = player.getDuration() * 1000;

        switch (event.data) {
            case YT.PlayerState.PLAYING:
                if (!iframe.dataset.started) {
                    iframe.dataset.started = 'true';

                    const data = {
                        event: 'video_start',
                        video_title: videoData.title,
                        video_url: videoData.url,
                        video_provider: videoData.provider,
                        video_duration: duration,
                        video_current_time: player.getCurrentTime() * 1000
                    };
                    window.dataLayer.push(data);

                    this.log('[Tracking] video_start', data);
                }

                // start progress tracking
                this.startProgressTracking(player, iframe, videoData);
                break;

            case YT.PlayerState.ENDED:
                const data = {
                    event: 'video_progress',
                    video_title: videoData.title,
                    video_url: videoData.url,
                    video_provider: videoData.provider,
                    video_percent: 100,
                    video_duration: duration,
                    video_current_time: duration
                };
                window.dataLayer.push(data);
                this.log('[Tracking] video_complete', data);

                clearInterval(this.youTubeProgressTimers[iframe.dataset.playerId]);
                break;
        }
    }
    ,

    startProgressTracking: function (player, iframe, videoData) {
        const id = iframe.dataset.playerId || Math.random().toString(36).substr(2, 9);
        iframe.dataset.playerId = id;

        const duration = player.getDuration();
        const milestones = [25, 50, 75];
        const done = {};

        if (this.youTubeProgressTimers[id]) return; // already tracking

        this.youTubeProgressTimers[id] = setInterval(() => {
            const current = player.getCurrentTime();
            const percent = (current / duration) * 100;

            milestones.forEach((milestone) => {
                if (percent >= milestone && !done[milestone]) {
                    done[milestone] = true;

                    const data = {
                        event: 'video_progress',
                        video_title: videoData.title,
                        video_url: videoData.url,
                        video_provider: videoData.provider,
                        video_percent: milestone,
                        video_duration: duration * 1000,
                        video_current_time: current * 1000
                    };
                    window.dataLayer.push(data);
                    this.log('[Tracking] video_progress', data);
                }
            });
        }, 1000);
    }
    ,

    trackContactForm: function (step, topic = '', hasErr, err) {
        if (!this.hasConsent || typeof window.dataLayer === 'undefined') return;

        const data = {
            event: 'form',
            form_type: 'contact',
            form_topic: topic,
            step: step,
            form_has_errors: hasErr,
            form_errors: err
        };
        window.dataLayer.push(data);
        this.log('[Tracking] form', data);
    }
};

export default Tracking;